import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion"] */ "/app/src/components/uikit/accordion/accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ArticleMeta"] */ "/app/src/components/uikit/blog/components/article-meta/ArticleMeta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ArticleSection"] */ "/app/src/components/uikit/blog/sections/article-section/ArticleSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/style/blog.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/uikit/blog/components/file-item/FileItem.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/uikit/blog/sections/files-section/FilesSection.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/uikit/blog/sections/header-section/HeaderSection.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/uikit/blog/components/info-card/InfoCard.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/uikit/blog/sections/article-info-section/ArticleInfoSection.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/uikit/breadcrumb/Breadcrumb.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/uikit/blog/sections/breadcrumb-section/BreadcrumbSection.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/uikit/blog/sections/accordion-section/AccordionSection.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/uikit/blog/components/blog-preview/BlogPreview.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/uikit/blog/sections/blog-grid-section/BlogGridSection.module.css");
